import type { HttpVerb, ExtractSpecificVerbRoutes, RouteSegment } from '@openclassrooms/sdk';

import { clientApi } from '../modules/configuration';

import type { ApiRoutes, GlobalRequestBuilder, RequestOption } from '../types';

export default function executeRequest<
  Verb extends HttpVerb,
  Path extends ExtractSpecificVerbRoutes<Verb, ApiRoutes> & RouteSegment,
  RequestBuilder extends GlobalRequestBuilder<Verb, Path> = GlobalRequestBuilder<Verb, Path>
>(
  verb: Verb,
  path: Path,
  options?: RequestOption<RequestBuilder> & {
    pagination?: {
      rangeStart?: number;
      rangeEnd?: number;
    };
  }
) {
  const { routeParams, queryParams, headers, body, pagination } = options as any;

  const client = clientApi.getLightOCClient();

  const request = client.createRequest(path, verb);

  if (routeParams) {
    request.setRouteParams(routeParams);
  }

  if (queryParams) {
    request.setQueryParams(queryParams);
  }

  if (headers) {
    request.setHeaders(headers);
  }

  if (body) {
    request.setBody(body);
  }

  if (pagination) {
    const paginationStart = pagination.rangeStart ?? 0;
    request.paginate(paginationStart, pagination.rangeEnd ?? paginationStart + 19);
  }

  return request.execute();
}
